<template>
  <div class="container-fluid">
    <div>
      <div class="row card">
        <div class="col-md-12" id="prof">
          <div class="card-body">
            <table class="table">
              <thead style="background-color: #003667; color: white">
                <tr class="text-center">
                  <td>Code</td>
                  <td>Professeur</td>
                  <td>établissement</td>
                  <td>VH statutaire</td>
                  <td>VH statutaire encadrement</td>
                  <td>VH décharge</td>
                  <td>VH dechargé</td>
                  <td>VH réalisé</td>
                  <td>Période académique</td>
                  <td></td>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="text-center"
                  v-for="data in datas"
                  :key="`vac_${data.id}`"
                >
                  <td>#{{ prof.agresso }}</td>
                  <td>
                    {{ prof.nom }}
                    {{ prof.prenom }}
                  </td>
                  <td>{{ data.etablissement }}</td>
                  <td>{{ prof.vh_statutaire }}</td>
                  <td>{{ prof.vh_statutaire_encad }}</td>
                  <td>{{ data.vh_decharge }}</td>
                  <td>{{ data.vh_decharger }}</td>
                  <td>
                    {{ data.vh_realise }}
                    <i
                      v-if="data.vh_realise > data.vh_engage"
                      class="ml-2 fa fa-exclamation-triangle"
                      style="color: #ffd43b"
                    ></i>
                  </td>
                  <td>{{ data.annee_universitaire }}</td>
                  <td>
                    <button
                      @click="showVH(data.annee_universitaire)"
                      class="btn btn-outline-primary btn-sm btn-icon mr-2"
                    >
                      <i class="fa fa-eye"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VclTable } from "vue-content-loading";
export default {
  props: {
    prof: {},
  },
  components: {
    VclTable,
  },
  data() {
    return {
      datas: [],
      config: {
        headers: {
          Authorization: "Bearer " + this.prof.api_token,
        },
      },
    };
  },
  methods: {
    showVH(year) {
      window.location.href = "/vacataire/vh/show/" + year;
    },
  },
  beforeMount() {
    axios.get("/api/get/VHPermanent", this.config).then((res) => {
      this.datas = res.data;
      console.log(this.datas);
    });
  },
};
</script>
